import PropTypes from 'prop-types';
import { MapPin, Navigation, ExternalLink } from 'lucide-react';
import { Text, Stack } from '@/components/ui/index.js';
import styles from './LocationMap.module.css';

/**
 * LocationMap - Displays event location with map placeholder
 * Shows venue name, address, and directions button
 */
export function LocationMap({ location, onGetDirections }) {
  const { name, address, coordinates } = location;

  const handleGetDirections = () => {
    if (coordinates) {
      const { lat, lng } = coordinates;
      const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
      window.open(mapsUrl, '_blank');
    }
    if (onGetDirections) {
      onGetDirections();
    }
  };

  return (
    <div className={styles.locationMap}>
      <Stack direction="row" gap={2} align="center" className={styles.header}>
        <MapPin size={18} className={styles.headerIcon} />
        <Text size="base" weight="semibold" color="primary">
          Location
        </Text>
      </Stack>

      <div className={styles.mapContainer}>
        <div className={styles.mapPlaceholder}>
          <div className={styles.mapPulse} />
          <div className={styles.mapPin}>
            <MapPin size={32} className={styles.pinIcon} />
          </div>
          <div className={styles.mapGrid}>
            <div className={styles.gridLine} />
            <div className={styles.gridLine} />
            <div className={styles.gridLine} />
            <div className={styles.gridLine} />
          </div>
          <div className={styles.mapLabel}>
            <Text size="xs" color="muted">
              Map view
            </Text>
          </div>
        </div>
      </div>

      <div className={styles.locationInfo}>
        <Text size="base" weight="medium" color="primary" className={styles.venueName}>
          {name}
        </Text>
        <Text size="sm" color="secondary" className={styles.address}>
          {address}
        </Text>
      </div>

      <div className={styles.actions}>
        <button
          className={styles.directionsButton}
          onClick={handleGetDirections}
          aria-label="Get directions to venue"
        >
          <Navigation size={18} className={styles.buttonIcon} />
          <Text size="base" weight="medium" color="primary">
            Get Directions
          </Text>
          <ExternalLink size={14} className={styles.externalIcon} />
        </button>
      </div>
    </div>
  );
}

LocationMap.propTypes = {
  location: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    coordinates: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
    }),
  }).isRequired,
  onGetDirections: PropTypes.func,
};

export default LocationMap;
